import React, { useEffect, useRef, useState } from 'react';
import Button from '@ui/button/Button';
import useQueryString from '@common/utils/useQueryString';
import analytics from '@utils/analytics';
import Image from '@moncler/components/experience/EditorialImage';
const DigitalFlagshipMatterportModule = ({ storejson, cardjson }) => {
    const [storeId] = useQueryString('storeId');
    const [store, setStore] = useState(undefined);
    const [showIntro, setShowIntro] = React.useState(true);
    const [isIframeLoaded, setIsIframeLoaded] = React.useState(false);
    const overlayRef = useRef(null);
    const iframeRef = useRef(null);
    //@ts-ignore
    const [ctaAsButton, setCtaAsButton] = React.useState(!(window.innerWidth < window.mqObj.sm));
    const card = typeof cardjson === 'string' ? JSON.parse(cardjson) : undefined;
    const handleHideIntroAndPlay = () => {
        var _a, _b;
        analytics.storelocatorAction((((_a = store === null || store === void 0 ? void 0 : store.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '') + '-enter', ((_b = card === null || card === void 0 ? void 0 : card.ctaText) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '');
        if (!ctaAsButton)
            return;
        if ((card === null || card === void 0 ? void 0 : card.image) && overlayRef.current) {
            // Create a fade-out effect to overlayRef
            overlayRef.current.classList.add('fade-out');
            const timeoutId = setTimeout(() => {
                setShowIntro(false);
            }, 310);
            return () => clearTimeout(timeoutId);
        }
        else {
            setShowIntro(false);
        }
    };
    const handleGoToTextSquares = (event) => {
        var _a;
        event.preventDefault();
        const targetId = (_a = event.currentTarget.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.substring(1);
        const targetElement = document.getElementById(targetId);
        const storeDetailElement = document.querySelector('.flagship-store_detail');
        const locationDescriptionElement = document.querySelector('.flagship-page__location-description');
        const computedStyle = getComputedStyle(document.documentElement);
        const headerHeightValue = computedStyle.getPropertyValue('--header-height');
        const numericHeaderHeightValue = parseInt(headerHeightValue, 10);
        if (targetElement) {
            const elementRect = targetElement.getBoundingClientRect();
            const offsetTop = window.isMobile()
                ? window.scrollY + elementRect.top - ((storeDetailElement === null || storeDetailElement === void 0 ? void 0 : storeDetailElement.clientHeight) || 0) - ((locationDescriptionElement === null || locationDescriptionElement === void 0 ? void 0 : locationDescriptionElement.clientHeight) || 0) + 5
                : elementRect.top - ((storeDetailElement === null || storeDetailElement === void 0 ? void 0 : storeDetailElement.clientHeight) || 0) - ((locationDescriptionElement === null || locationDescriptionElement === void 0 ? void 0 : locationDescriptionElement.clientHeight) || 0) - (numericHeaderHeightValue || 0) + 5;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth',
            });
        }
    };
    useEffect(() => {
        if (storejson && typeof storejson === 'string') {
            setStore(JSON.parse(storejson));
        }
    }, [storejson, storeId]);
    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe)
            return;
        const checkIframeHeight = () => {
            if (ctaAsButton)
                return;
            const iframeHeight = iframe.clientHeight;
            const screenHeight = window.screen.height;
            const isIframeTallerThan70Percent = iframeHeight > screenHeight * 0.6;
            setCtaAsButton(isIframeTallerThan70Percent);
        };
        if (!ctaAsButton && isIframeLoaded) {
            checkIframeHeight();
        }
        const resizeObserver = new ResizeObserver(checkIframeHeight);
        resizeObserver.observe(iframe);
        return () => {
            resizeObserver.unobserve(iframe);
        };
    }, [ctaAsButton, store === null || store === void 0 ? void 0 : store.interactiveStoreModule, isIframeLoaded]);
    useEffect(() => {
        const handlePopState = () => {
            if (iframeRef.current) {
                iframeRef.current.src = iframeRef.current.src;
            }
        };
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
    if (!store) {
        return null;
    }
    return (React.createElement("div", { className: "flagship-page__matterport flex-full-height" },
        React.createElement("div", { className: "content flex-full-height" },
            React.createElement("div", { className: "container flex-full-height" },
                React.createElement("div", { className: "wrapper flex-full-height" },
                    showIntro && isIframeLoaded && (React.createElement("div", { ref: overlayRef, className: "overlay" },
                        (card === null || card === void 0 ? void 0 : card.image) && (React.createElement("div", { className: "overlay__background", "aria-hidden": "true" },
                            React.createElement(Image, Object.assign({ avoidMedia: true }, card === null || card === void 0 ? void 0 : card.image)))),
                        React.createElement("div", { className: "content__wrapper" },
                            React.createElement("div", { className: "content" },
                                (card === null || card === void 0 ? void 0 : card.title) && React.createElement("h1", { className: "title" }, card === null || card === void 0 ? void 0 : card.title),
                                (card === null || card === void 0 ? void 0 : card.description) && (React.createElement("div", { className: "description", dangerouslySetInnerHTML: {
                                        __html: card === null || card === void 0 ? void 0 : card.description,
                                    } })),
                                React.createElement("div", null, ctaAsButton ? (React.createElement(Button, { disabled: !isIframeLoaded, type: "button", cls: ['button--primary-inverted'], className: "cta", onClick: handleHideIntroAndPlay }, card === null || card === void 0 ? void 0 : card.ctaText)) : (React.createElement("a", { href: `https://my.matterport.com/show/?m=${store === null || store === void 0 ? void 0 : store.interactiveStoreModule}`, className: "button--primary-inverted cta", onClick: handleHideIntroAndPlay, target: "_blank", rel: "noopener noreferrer" }, card === null || card === void 0 ? void 0 : card.ctaText))))))),
                    (store === null || store === void 0 ? void 0 : store.interactiveStoreModule) && (React.createElement("div", { className: "matterport-showcase flex-full-height" },
                        React.createElement("iframe", { ref: iframeRef, allowFullScreen: true, src: `https://my.matterport.com/show/?m=${store === null || store === void 0 ? void 0 : store.interactiveStoreModule}`, width: "100%", height: "100%", onLoad: () => setIsIframeLoaded(true), allow: "xr-spatial-tracking" }))))),
            React.createElement("div", { className: "flagship-store_detail" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "grid-1-1 detail__title-wrapper" },
                        React.createElement("h2", { className: "detail__title" }, store === null || store === void 0 ? void 0 : store.name)),
                    React.createElement("div", { className: "grid-1-1 detail__cta-wrapper" },
                        React.createElement("a", { href: "#text-squares", className: "detail__cta", onClick: handleGoToTextSquares },
                            React.createElement("span", null, card === null || card === void 0 ? void 0 : card.anchorLinkText),
                            React.createElement("i", { className: "icon--chevron-down-double" }))))))));
};
export default DigitalFlagshipMatterportModule;
